import React from "react";

const PlaceOrder = ({ isSidebarOpen = true }) => {
  return (
    <>
      <div className={`${isSidebarOpen ? "col-lg-9" : "col-lg-12"} pt-4 pb-2 pb-sm-4`}>
        <div>PlaceOrder</div>
      </div>
    </>
  );
};

export default PlaceOrder;
